import { useState } from '../c-mp/fun/useState'
import type { IData } from './IData'
import { Page } from './Page'

export const appState = useState('appState', {
	data: undefined as IData | undefined,
	pathMatch: null as URLPatternResult | null,
	page: Page.NotFound,
})
